import {
  ComponentFactoryResolver,
  Injectable,
  Inject,
  ReflectiveInjector
} from "@angular/core";
import { JobsiteCreateComponent } from "@fs/components/customer/jobsite-create/jobsite-create.component";
import { Tabs } from "@enums/tab.enum";
import { CustomerSearchLteComponent } from "@fs/components/customer/cust-search/cust-search.component";
import { FsLiteCustomerCreateComponent } from "@fs/components/customer/cust-create/cust-create.component";
import { SettingDashboardComponent } from "@fs/components/setting/dashboard/dashboard.component";
import { TradeListComponent } from "@fs/components/product-category/trade-list/trade-list.component";
import { WorkOrderListComponent } from "@fs/components/work-order/wo-list/wo-list.component";
import { WorkOrderCreateComponent } from "@fs/components/work-order/wo-create/wo-create.component";
import { WorkOrderDetailComponent } from "@fs/components/work-order/wo-detail/wo-detail.component";
import { MaterialItemCreateComponent } from "@fs/components/price-book/material-item/material-create/material-create.component";
import { WorkOrderEditComponent } from "@fs/components/work-order/wo-edit/wo-edit.component";
import { LaborItemFormComponent } from "@fs/components/price-book/labor-item/labor-create/labor-create.component";
import { MaterialItemDetailComponent } from "@fs/components/price-book/material-item/material-detail/material-detail.component";
import { LaborItemDetailComponent } from "@fs/components/price-book/labor-item/labor-detail/labor-detail.component";
import { ServiceItemFormComponent } from "@fs/components/price-book/service-item/service-create/service-create.component";
import { ServiceItemViewComponent } from "@fs/components/price-book/service-item/service-detail/service-detail.component";
import { AccountingLogComponent } from "@fs/components/accounting-log/accounting-log.component";
import { WorkOrderReviewListComponent } from "@fs/components/work-order-review/wo-review-list/wo-review-list.component";
import { WorkOrderReviewEditComponent } from "@fs/components/work-order-review/wo-review-edit/wo-review-edit.component";
import { WorkOrderReviewDetailComponent } from "@fs/components/work-order-review/wo-review-detail/wo-review-detail.component";
import { DashboardComponent } from "@fs/components/dashboard/dashboard.component";
import { CustomerJobsiteEditComponent } from '@fs/components/customer/customer-jobsite-edit/customer-jobsite-edit.component'
import { ImportDataComponent } from "@fs/components/utilities/import-data/import-data.component";
import { WoDispatcherComponent } from "@fs/components/work-order/wo-dispatcher/wo-dispatcher.component";
import { CustManageComponent } from "@fs/components/customer/cust-manage/cust-manage.component";
import { ReportsDashboardComponent } from "@fs/components/reports/reports-dashboard/reports-dashboard.component";
import { SaItemCreateComponent } from "@fs/components/price-book/agreement-item/create/create.component";
import { SaItemViewComponent } from "@fs/components/price-book/agreement-item/view/view.component";
import { SaCreateComponent } from "@fs/components/agreement/create/create.component";
import { SaViewComponent } from "@fs/components/agreement/view/view.component";
import { SaListComponent } from "@fs/components/agreement/list/list.component";
import { PbListComponent } from "@fs/components/price-book/list/list.component";
import { VisitListComponent } from "@fs/components/visit/list/list.component";
import { EstimateCreateComponent } from "@fs/components/estimates/create/create.component";
import { EstimateViewComponent } from "@fs/components/estimates/view/view.component";
import { EstimateListComponent } from "@fs/components/estimates/list/list.component";

@Injectable()
export class ContentDynamicLoader {
  factoryResolver: any;
  rootViewContainer: any;
  constructor(@Inject(ComponentFactoryResolver) factoryResolver) {
    this.factoryResolver = factoryResolver;
  }
  setRootViewContainerRef(viewContainerRef) {
    this.rootViewContainer = viewContainerRef;
  }
  addDynamicComponent(tabId: number, tabParams: any, tabCounter: number) {
    var factory;
    switch (tabId) {

      case Tabs.NewJobSite:
        factory = this.factoryResolver.resolveComponentFactory(
          JobsiteCreateComponent
        );
        break;

      case Tabs.CustomerSearchLte:
        factory = this.factoryResolver.resolveComponentFactory(
          CustomerSearchLteComponent
        );
        break;

      case Tabs.FsLiteNewCustomer:
        factory = this.factoryResolver.resolveComponentFactory(
          FsLiteCustomerCreateComponent
        );
        break;
      case Tabs.FsLiteSettingDashboard:
        factory = this.factoryResolver.resolveComponentFactory(
          SettingDashboardComponent
        );
        break;
      case Tabs.FsLiteTradeList:
        factory = this.factoryResolver.resolveComponentFactory(
          TradeListComponent
        );
        break;
      case Tabs.FsLiteWorkOrderList:
        factory = this.factoryResolver.resolveComponentFactory(
          WorkOrderListComponent
        );
        break;
      case Tabs.FsLiteWorkOrderCreate:
        factory = this.factoryResolver.resolveComponentFactory(
          WorkOrderCreateComponent
        );
        break;
      case Tabs.FsLiteWorkOrderView:
        factory = this.factoryResolver.resolveComponentFactory(
          WorkOrderDetailComponent
        );
        break;
      case Tabs.FsLitePriceBookList:
        factory = this.factoryResolver.resolveComponentFactory(
          PbListComponent
        );
        break;
      case Tabs.FsLiteMaterialItemCreate:
        factory = this.factoryResolver.resolveComponentFactory(
          MaterialItemCreateComponent
        );
        break;
      case Tabs.FsLiteWorkOrderEdit:
        factory = this.factoryResolver.resolveComponentFactory(
          WorkOrderEditComponent
        );
        break;
      case Tabs.FsLiteLaborItemCreate:
        factory = this.factoryResolver.resolveComponentFactory(
          LaborItemFormComponent
        );
        break;
      case Tabs.FsLiteLaborItemDetail:
        factory = this.factoryResolver.resolveComponentFactory(
          LaborItemDetailComponent
        );
        break;
      case Tabs.FsLiteMaterialItemDetail:
        factory = this.factoryResolver.resolveComponentFactory(
          MaterialItemDetailComponent
        );
        break;
      case Tabs.FsLiteServiceItemForm:
        factory = this.factoryResolver.resolveComponentFactory(
          ServiceItemFormComponent
        );
        break;
      case Tabs.FsLiteServiceItemView:
        factory = this.factoryResolver.resolveComponentFactory(
          ServiceItemViewComponent
        );
        break;
      case Tabs.FsLiteLaborItemEdit:
        factory = this.factoryResolver.resolveComponentFactory(
          LaborItemFormComponent
        );
        break;
      case Tabs.FsLiteMaterialItemEdit:
        factory = this.factoryResolver.resolveComponentFactory(
          MaterialItemCreateComponent
        );
        break;
      case Tabs.FsLiteServiceItemEdit:
        factory = this.factoryResolver.resolveComponentFactory(
          ServiceItemFormComponent
        );
        break;
      case Tabs.FsLiteAccountingLog:
        factory = this.factoryResolver.resolveComponentFactory(
          AccountingLogComponent
        );
        break;
      case Tabs.FsLiteWorkOrderReview:
        factory = this.factoryResolver.resolveComponentFactory(
          WorkOrderReviewListComponent
        );
        break;
      case Tabs.FsLiteWorkOrderReviewEdit:
        factory = this.factoryResolver.resolveComponentFactory(
          WorkOrderReviewEditComponent
        );
        break;
      case Tabs.FsLiteWorkOrderReviewView:
        factory = this.factoryResolver.resolveComponentFactory(
          WorkOrderReviewDetailComponent
        );
        break;
      case Tabs.Dashboard:
        factory = this.factoryResolver.resolveComponentFactory(
          DashboardComponent
        );
        break;
      case Tabs.FsLiteCustomerJobSiteEdit:
        factory = this.factoryResolver.resolveComponentFactory(
          CustomerJobsiteEditComponent
        );
        break;
      case Tabs.FsLiteImportData:
        factory = this.factoryResolver.resolveComponentFactory(
          ImportDataComponent
        );
        break;
      case Tabs.FsLiteWorkOrderDispatcher:
        factory = this.factoryResolver.resolveComponentFactory(
          WoDispatcherComponent
        );
        break;
      case Tabs.CustomerLandingPage:
        factory = this.factoryResolver.resolveComponentFactory(
          CustManageComponent
        );
        break;
      case Tabs.FsLiteReportsDashboard:
        factory = this.factoryResolver.resolveComponentFactory(
          ReportsDashboardComponent
        );
        break;
      case Tabs.FsLiteServiceAgreementItem:
        factory = this.factoryResolver.resolveComponentFactory(
          SaItemCreateComponent
        );
        break;
      case Tabs.FsLiteServiceAgreementItemDetail:
        factory = this.factoryResolver.resolveComponentFactory(
          SaItemViewComponent
        );
        break;
      case Tabs.ServiceAgreementEdit:
      case Tabs.NewServiceAgreement:
        factory = this.factoryResolver.resolveComponentFactory(
          SaCreateComponent
        );
        break;
      case Tabs.ServiceAgreementDetail:
        factory = this.factoryResolver.resolveComponentFactory(
          SaViewComponent
        );
        break;
      case Tabs.ServiceAgreement:
        factory = this.factoryResolver.resolveComponentFactory(
          SaListComponent
        );
        break;
      case Tabs.Visit:
        factory = this.factoryResolver.resolveComponentFactory(
          VisitListComponent
        );
        break;
      case Tabs.VisitCustomerContact:
        factory = this.factoryResolver.resolveComponentFactory(
          VisitListComponent
        );
        break;
      case Tabs.NewEstimate:
        factory = this.factoryResolver.resolveComponentFactory(
          EstimateCreateComponent
        );
        break;
      case Tabs.EstimateEdit:
        factory = this.factoryResolver.resolveComponentFactory(
          EstimateCreateComponent
        );
        break;
      case Tabs.EstimateDetail:
        factory = this.factoryResolver.resolveComponentFactory(
          EstimateViewComponent
        );
        break;
      case Tabs.EstimateList:
        factory = this.factoryResolver.resolveComponentFactory(
          EstimateListComponent
        );
        break;
    }
    const component = factory.create(this.rootViewContainer.parentInjector);
    component.instance.inputParams = tabParams;
    component.instance.tabCounter = tabCounter;
    this.rootViewContainer.detach();
    this.rootViewContainer.insert(component.hostView);
  }
}